// 6-dimension fit breakdown card — the "why 84?" explainer from JobDetail.
// README § Common pitfalls: store all 6 dimensions explicitly, don't black-box.

import Progress from '../ui/Progress';
import type { FitBreakdown } from '../../lib/types';
import { useZh } from '../../lib/useProduct';

interface Props {
  score: number;              // overall 0-100
  breakdown: FitBreakdown | null;
}

const LABELS: { key: keyof FitBreakdown; label: string; zh: string }[] = [
  { key: 'mission', label: 'Mission', zh: '岗位方向' },
  { key: 'technical_match', label: 'Technical match', zh: '技术匹配' },
  { key: 'comp_vs_target', label: 'Comp vs target', zh: '薪资' },
  { key: 'location', label: 'Location', zh: '地点' },
  { key: 'pace', label: 'Pace', zh: '工作节奏' },
  { key: 'growth', label: 'Growth', zh: '成长空间' },
];

export default function FitScoreCard({ score, breakdown }: Props) {
  const zh = useZh();
  return (
    <div
      className="card"
      style={{ padding: 22, background: 'linear-gradient(170deg, #f5f7f5 0%, #fff 70%)' }}
    >
      <div className="tab" style={{ marginBottom: 8 }}>
        {zh ? '你的匹配分' : 'Your fit score'}
      </div>
      <div className="num" style={{ fontSize: 72, lineHeight: 1, color: 'var(--pri)' }}>
        {score}
      </div>
      <div style={{ fontSize: 12, color: 'var(--ink3)', marginTop: 4 }}>
        {zh ? '满分 100 · 按你的个人画像加权' : 'out of 100 · weighted against your profile'}
      </div>
      <div className="hair" style={{ margin: '18px 0' }} />
      {breakdown ? (
        LABELS.map(({ key, label, zh: zhLabel }) => {
          const v = breakdown[key];
          return (
            <div
              key={key}
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', fontSize: 12.5 }}
            >
              {/* Auto-width instead of a fixed 110px: the Chinese labels are
                  shorter than the English they replaced, and a fixed width sized
                  for "Technical match" left a visible gap before every bar. */}
              <div style={{ minWidth: zh ? 68 : 110, color: 'var(--ink2)' }}>{zh ? zhLabel : label}</div>
              <Progress value={v ?? 0} style={{ flex: 1, opacity: v == null ? 0.35 : 1 }} />
              <div style={{ width: 28, textAlign: 'right', fontWeight: 500 }}>
                {v == null ? '—' : v}
              </div>
            </div>
          );
        })
      ) : (
        <div style={{ fontSize: 12, color: 'var(--ink3)', fontStyle: 'italic' }}>
          {zh ? '这个职位评估完成后，各维度分数会显示在这里。' : 'Dimensions will appear once this role is evaluated.'}
        </div>
      )}
    </div>
  );
}
